//Формирование url для редиректа после авторизации и для обращения к апи
// const host = window.location.host;
//const host = 'hlassistant.ru'; //PROD
// const host = 'newstaging.devhlassistant.ru'; //STAGING
//const host = 'apidev.devhlassistant.ru'; //DEV
// const protocol = window.location.protocol;
// const url = protocol + '//' + host;

export default {
  //devHost: 'https://hlassistant.ru',
  devHost: process.env.REACT_APP_BASE, //STAGING
  prodHost: process.env.REACT_APP_BASE,
  base: process.env.REACT_APP_BASE,
  prefix: "/api/v11/site",
  url: process.env.REACT_APP_BASE,
};
